import { ErrorMessage } from "formik";
import { LoginFormData, LoginStepProps } from "./StepModel";
import { Dispatch } from "react";
import OtpInput from "react-otp-input";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  requestNewVerificationCode,
  selectStatus,
  selectTwoFactorAuthType,
  setStatus,
  verifyUser,
} from "../LoginPageSlice";
import { useDispatch, useSelector } from "react-redux";
import { TwoFactorAuthenticationTypes } from "global/enums";
import { useThunkDispatch } from "setup/redux/thunkDispatch";

export const TwoFactorAuthStep: React.FC<LoginStepProps> = ({ currentStep, formikProps }: LoginStepProps) => {
  const twoFactorAuthType = useSelector(selectTwoFactorAuthType);
  const status = useSelector(selectStatus);
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();

  const get2FAText = () => {
    switch (twoFactorAuthType) {
      case TwoFactorAuthenticationTypes.Email:
        return "We have sent a code to your email:";
      case TwoFactorAuthenticationTypes.TOTP:
        return "Please enter the code from your authenticator app:";
    }
  };

  return (
    <>
      {twoFactorAuthType !== undefined && (
        <div className="fv-row mb-3">
          <div className="verification-code-section">
            <div className="verification-code-label">{get2FAText()}</div>
            <OtpInput
              inputStyle="inputStyle"
              value={formikProps.values.oneTimePassword}
              onChange={(otp: string) => {
                formikProps.setFieldValue("oneTimePassword", otp);
                if (status !== "") {
                  dispatch(setStatus(""));
                }
              }}
              numInputs={6}
              inputType="number"
              renderSeparator={(index) => (index === 2 ? <span>-</span> : "")}
              renderInput={(props, index) => <input {...props} data-test-id={`login-form__code-input-${index}`} />}
            />
          </div>
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <ErrorMessage name="oneTimePassword" key={currentStep.toString()} />
            </div>
          </div>
          {twoFactorAuthType === TwoFactorAuthenticationTypes.Email ? (
            <div
              onClick={() =>
                thunkDispatch(
                  requestNewVerificationCode({
                    emailAddress: formikProps.values.emailAddress,
                    password: formikProps.values.password,
                  })
                )
              }
              className="cpl-text-primary fs-base fw-semibold text-decoration-underline cursor-pointer text-end"
              data-test-id="login-form__request-new-code-button"
            >
              Request new verification code
            </div>
          ) : (
            <div className="mt-5"></div>
          )}
        </div>
      )}
    </>
  );
};

export const TwoFactorAuthSubmit = async (
  values: LoginFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  thunkDispatch(
    verifyUser({
      emailAddress: values.emailAddress,
      password: values.password,
      oneTimePassword: values.oneTimePassword,
    })
  );
};
